import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { LightStreaks } from "./LightStreaks";
import { useReveal } from "../hooks/useReveal";

export const Hero = () => {
  const ref = useReveal();
  return (
    <section
      id="top"
      ref={ref}
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-center justify-center overflow-hidden noise-bg grain"
    >
      <LightStreaks density={9} />

      {/* Faint grid */}
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.4) 1px, transparent 1px)",
          backgroundSize: "56px 56px",
          maskImage:
            "radial-gradient(ellipse at center, black 30%, transparent 75%)",
          WebkitMaskImage:
            "radial-gradient(ellipse at center, black 30%, transparent 75%)",
        }}
      />

      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-10 py-32 text-center">
        <div className="reveal inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/15 bg-white/5 backdrop-blur-sm mb-8">
          <span className="pulse-dot" />
          <span className="text-xs tracking-[0.18em] uppercase text-white/80 font-medium">
            Agencja Stormly · Web Design Premium
          </span>
        </div>

        <h1
          data-testid="hero-headline"
          className="reveal reveal-delay-1 font-heading font-black text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[1.02] tracking-tight max-w-5xl mx-auto"
        >
          Rozświetl swoją markę{" "}
          <span className="relative inline-block">
            <span className="text-primary-cyan">w sieci</span>
            <svg
              className="absolute -bottom-3 left-0 w-full"
              viewBox="0 0 300 12"
              fill="none"
              preserveAspectRatio="none"
            >
              <path
                d="M2 8 Q 75 2 150 7 T 298 6"
                stroke="#00FFFF"
                strokeWidth="2"
                strokeLinecap="round"
                opacity="0.7"
              />
            </svg>
          </span>
          .
        </h1>

        <p
          data-testid="hero-subtitle"
          className="reveal reveal-delay-2 mt-8 text-lg sm:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed"
        >
          Tworzymy strony WordPress dla firm, które chcą{" "}
          <span className="text-white">więcej klientów</span> — szybciej,
          ładniej i z lepszym kontaktem niż gdziekolwiek indziej.
        </p>

        <div className="reveal reveal-delay-3 mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#kontakt"
            data-testid="hero-cta-primary"
            className="btn-primary"
          >
            Zamów stronę
            <ArrowRight size={18} />
          </a>
          <a
            href="#kontakt"
            data-testid="hero-cta-secondary"
            className="btn-ghost"
          >
            <Sparkles size={16} />
            Darmowa wycena
          </a>
        </div>

        <div className="reveal reveal-delay-4 mt-16 flex flex-wrap items-center justify-center gap-x-10 gap-y-4 text-sm text-white/50">
          <div className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-stormly-cyan" />
            Realizacja od 7 dni
          </div>
          <div className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-stormly-cyan" />
            Od 1000 zł
          </div>
          <div className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-stormly-cyan" />
            Wsparcie po wdrożeniu
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-[#1A1A2E] to-transparent pointer-events-none" />
    </section>
  );
};
